import {
  DRUPAL_NODE_DISPLAY,
  type DrupalImage,
  type DrupalNodePage,
  type DrupalTerm,
} from '@commons/types/drupal';

import WhitePaperNodeCard from './Card';
import WhitePaperNodeFeatured from './Featured';
import WhitePaperNodeFeaturedTile from './FeaturedTile';
import WhitePaperNodeLabel from './Label';
import WhitePaperNodeSmallCard from './SmallCard';
import WhitePaperNodeTeaser from './Teaser';

/**
 * Type definition of a WhitePaper node properties.
 */

export type WhitePaperNodeProps = DrupalNodePage & {
  date: string;
  image?: DrupalImage;
  format?: DrupalTerm;
  authors?: string;
  summary?: string;
};

/**
 * WhitePaper node component.
 *
 * Renders a component based on the display type.
 */

export const WhitePaperNode = (props: WhitePaperNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <WhitePaperNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Teaser:
      return <WhitePaperNodeTeaser {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <WhitePaperNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.SmallCard:
      return <WhitePaperNodeSmallCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <WhitePaperNodeFeatured {...props} />;
    case DRUPAL_NODE_DISPLAY.FeaturedTile:
      return <WhitePaperNodeFeaturedTile {...props} />;
  }
};

export default WhitePaperNode;
